export const pageConstants = {
    public_pages: ['/terms', '/privacy'],
    support_email: 'support@upprovall.com'
}
;